import { render, staticRenderFns } from "./CollabBoardModal.vue?vue&type=template&id=4ac41e6d&scoped=true"
import script from "./CollabBoardModal.vue?vue&type=script&lang=js"
export * from "./CollabBoardModal.vue?vue&type=script&lang=js"
import style0 from "./CollabBoardModal.vue?vue&type=style&index=0&id=4ac41e6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac41e6d",
  null
  
)

export default component.exports